import { render, staticRenderFns } from "./BaseStatuses.vue?vue&type=template&id=750b01ba&"
import script from "./BaseStatuses.vue?vue&type=script&lang=js&"
export * from "./BaseStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports